import * as React from 'react'
import {Alert, Col, Form, Modal, notification, Row, Spin} from 'antd';
import {FormComponentProps} from 'antd/lib/form';
import {withTranslation, WithTranslation} from 'react-i18next';
import {NewProjectTaskAssignmentItem, NewProjectTaskAssignmentStore} from 'src/stores/projecttaskassignments-store';
import {connect} from 'redux-scaffolding-ts'
import {nameof} from 'src/core/utils/object';
import autobind from 'autobind-decorator';
import {GetFieldDecoratorOptions} from 'antd/lib/form/Form';
import {formatMessage} from 'src/core/services/http.service';
import ProjectTaskEditor from 'src/components/projecttask-editor';
import ProjectMemberEditor from 'src/components/project-member-editor';

let FormItem = Form.Item;

interface NewProjectTaskAssignmentViewProps {
    companyId: string,
    projectId: string,
    isPrivateProject: boolean;
    onClose: (id: string | undefined, item?: NewProjectTaskAssignmentItem) => void;
    companyAllowCir: boolean;
    companyAllowCii: boolean;
}

interface NewProjectTaskAssignmentViewState {
    
}

interface ClassFormBodyProps extends WithTranslation {
    companyId: string,
    projectId: string,
    isPrivateProject: boolean;
    item: NewProjectTaskAssignmentItem | undefined,
    onSave?: () => Promise<any>;
    getFieldDecorator<T extends Object = {}>(id: keyof T, options?: GetFieldDecoratorOptions): (node: React.ReactNode) => React.ReactNode;
    companyAllowCir: boolean;
    companyAllowCii: boolean;
}

export class ProjectTaskAssignmentFormBody extends React.Component<ClassFormBodyProps, { employeeId: string }> {
    constructor(props: ClassFormBodyProps) {
        super(props);
        this.state = {
            employeeId: ''
        };
    }
    render() {
        const { t } = this.props;

        var item = this.props.item || {} as NewProjectTaskAssignmentItem;
        return <Form id="modaForm" onKeyUp={(e) => { if (e.keyCode === 13 && this.props.onSave) { this.props.onSave(); } }} onSubmit={() => { if (this.props.onSave) { this.props.onSave(); } }}>
            <Row gutter={24}>
                <Col span={12}>
                    <FormItem label={t("Employee")}>
                        {this.props.getFieldDecorator(nameof<NewProjectTaskAssignmentItem>('employeeId'), {
                            initialValue: item.employeeId,
                            rules: [{ required: true, message: t('Employee is required') }],
                        })(
                            <ProjectMemberEditor projectId={this.props.projectId} onChange={(value) => { this.setState({ employeeId: `${value}` }) }} placeholder={t("Employee")} companyId={this.props.companyId} />
                        )}
                    </FormItem>
                   
                </Col>
                <Col span={12}>
                    <FormItem label={t("Project task")}>
                        {this.props.getFieldDecorator(nameof<NewProjectTaskAssignmentItem>('projectTaskId'), {
                            initialValue: item.projectTaskId,
                            rules: [{ required: true, message: t('Project Task required') }],
                        })(
                            <ProjectTaskEditor companyAllowCii={this.props.companyAllowCii} companyAllowCir={this.props.companyAllowCir} excludeAssignments disabled={!this.state.employeeId} employeeId={this.state.employeeId} companyId={this.props.companyId} projectId={this.props.projectId} placeholder={t("Name")} nullable multiple />
                        )}
                    </FormItem>
                </Col>
            </Row>
            <small>{t("Assignment of tasks only to project members")}</small>
        </Form>
    }
}

@connect(["newProjectTaskAssignment", NewProjectTaskAssignmentStore])
class NewProjectTaskAssignmentView extends React.Component<NewProjectTaskAssignmentViewProps & WithTranslation & FormComponentProps, NewProjectTaskAssignmentViewState> {
    private get newProjectTaskAssignmentStore() {
        return (this.props as any).newProjectTaskAssignment as NewProjectTaskAssignmentStore;
    }

    constructor(props: NewProjectTaskAssignmentViewProps & WithTranslation & FormComponentProps) {
        super(props);
        this.newProjectTaskAssignmentStore.createNew({} as any);
        this.newProjectTaskAssignmentStore.changeUrl(this.props.companyId, this.props.projectId);
    }

    componentWillReceiveProps(nextProps: NewProjectTaskAssignmentViewProps) {
        if (this.newProjectTaskAssignmentStore.state.result && this.newProjectTaskAssignmentStore.state.result.isSuccess)
            nextProps.onClose((this.newProjectTaskAssignmentStore.state.result as any).aggregateRootId, this.newProjectTaskAssignmentStore.state.item)
    }

    @autobind
    private countDownNotification(_notification: any, message: string, description: string, key: string) {
        let secondsToGo = 4;
        _notification({
            key: key,
            message: message + `(${secondsToGo}).`,
            description: description
        });
        const timer = setInterval(() => {
            secondsToGo -= 1;
            _notification({
                key: key,
                message: message + `(${secondsToGo}).`,
                description: description,
            });
        }, 1000);
        setTimeout(() => {
            clearInterval(timer);
            notification.close(key);
        }, secondsToGo * 1000);
    }

    @autobind
    private onCreateNewItem() {
        if (this.newProjectTaskAssignmentStore.state.isBusy)
            return new Promise(() => { })
        var self = this;
        const { t } = this.props;
        return new Promise((resolve, reject) => {
            self.props.form.validateFields(event => {
                var values = self.props.form.getFieldsValue();
                if (!event) {
                    values = { ...values, projectId: this.props.projectId };
                    self.newProjectTaskAssignmentStore.change(values);
                    self.newProjectTaskAssignmentStore.submit().then(result => {
                        if (result.isSuccess) {
                            resolve();
                            this.countDownNotification(notification.success, t("Notification"), t("Assignment was created successfully"), "success");
                        } else {
                            reject();
                            this.countDownNotification(notification.error, t("Error"), t("There was an error. Assignment was not created."), "failure");
                        }
                    });
                }
            });
        })
    }

    @autobind
    private onCancelNewItem() {
        this.newProjectTaskAssignmentStore.clear();
        this.props.onClose(undefined);
    }

    public render() {
        const { t } = this.props;
        const { getFieldDecorator } = this.props.form;
        return (
            <Modal
                maskClosable={false}
                visible
                onCancel={this.onCancelNewItem}
                onOk={this.onCreateNewItem}
                closable={false}
                width='800px'
                title={t("New assignment")}>
                {this.newProjectTaskAssignmentStore.state.result && !this.newProjectTaskAssignmentStore.state.result.isSuccess &&
                    <Alert type='error'
                        message={t("Error")}
                        description={formatMessage(this.newProjectTaskAssignmentStore.state.result)}
                    />
                }
                <Spin spinning={this.newProjectTaskAssignmentStore.state.isBusy}>
                    <ProjectTaskAssignmentFormBody companyAllowCii={this.props.companyAllowCii} companyAllowCir={this.props.companyAllowCir} isPrivateProject={this.props.isPrivateProject} companyId={this.props.companyId} projectId={this.props.projectId} i18n={this.props.i18n} t={this.props.t} tReady={this.props.tReady} item={this.newProjectTaskAssignmentStore.state.item} getFieldDecorator={getFieldDecorator} onSave={this.onCreateNewItem} />
                </Spin>
            </Modal>
        );
    }
}

// Wire up the React component to the Redux store
export default withTranslation()(Form.create({})(NewProjectTaskAssignmentView as any) as any) as any as React.ComponentClass<NewProjectTaskAssignmentViewProps>;